const found = {
  path: 'found',
  component: resolve => require(['@/pages/admin/reviewed/alipay/found'], resolve),
  meta: {isFound: true}
}

export default found
